// src/App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClientPage from './pages/ClientPage';
import TiKanePage from './pages/TiKanePage';
import TransactionPage from './pages/TransactionPage';
import UserPage from './pages/UserPage';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingOverlay from './components/LoadingOverlay';

import TiKaneSenpPage from './pages/TiKaneSenpPage';
import ZellePage from './pages/ZellePage';
import DailyRatePage from './pages/DailyRatePage';
import MoncashPage from './pages/MoncashPage';
import MoncashFeesPage from './pages/MoncashFeesPage';
import NatcashPage from './pages/NatcashPage';
import NatcashFeesPage from './pages/NatcashFeesPage';
import ExchangePage from './pages/ExchangePage';
import MicroCreditPage from './pages/MicroCreditPage';
import CashSessionPage from './pages/CashSessionPage';
import CashOpeningManagementPage from './pages/CashOpeningManagementPage';

// NOUVEAU
import PrintSettingsPage from './pages/PrintSettingsPage';

export default function App() {
  return (
    <>
      <LoadingOverlay />

      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/clients"
          element={
            <ProtectedRoute>
              <Sidebar />
              <ClientPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/tikane"
          element={
            <ProtectedRoute>
              <Sidebar />
              <TiKanePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/tikanesenp"
          element={
            <ProtectedRoute>
              <Sidebar />
              <TiKaneSenpPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/transactions"
          element={
            <ProtectedRoute>
              <Sidebar />
              <TransactionPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Sidebar />
              <UserPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/daily-rate"
          element={
            <ProtectedRoute>
              <Sidebar />
              <DailyRatePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/zelle"
          element={
            <ProtectedRoute>
              <Sidebar />
              <ZellePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/moncash"
          element={
            <ProtectedRoute>
              <Sidebar />
              <MoncashPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/moncash-fees"
          element={
            <ProtectedRoute>
              <Sidebar />
              <MoncashFeesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/natcash"
          element={
            <ProtectedRoute>
              <Sidebar />
              <NatcashPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/natcash-fees"
          element={
            <ProtectedRoute>
              <Sidebar />
              <NatcashFeesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/exchange"
          element={
            <ProtectedRoute>
              <Sidebar />
              <ExchangePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/microcredit"
          element={
            <ProtectedRoute>
              <Sidebar />
              <MicroCreditPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/cash-sessions"
          element={
            <ProtectedRoute>
              <Sidebar />
              <CashSessionPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/cash-openings"
          element={
            <ProtectedRoute>
              <Sidebar />
              <CashOpeningManagementPage />
            </ProtectedRoute>
          }
        />

        {/* NOUVEAU */}
        <Route
          path="/print-settings"
          element={
            <ProtectedRoute>
              <Sidebar />
              <PrintSettingsPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </>
  );
}